import Header from "./Header";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-white text-[#2D1820]">
      <Header />
      <main className="pt-16">{children}</main>
      <footer className="mt-24 border-t border-[#E8DFDC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#635057]">
          <div className="flex items-center gap-2">
            <span aria-hidden>🥻</span>
            <span className="tracking-widest uppercase">Saree Tryon Studio</span>
          </div>
          <div className="tracking-widest uppercase">Crafted with care · Powered by AI</div>
        </div>
      </footer>
    </div>
  );
}
